export const Duplicate = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.33331 1.33398H13.3333C14.0686 1.33398 14.6666 1.93198 14.6666 2.66732V10.6673H13.3333V2.66732H5.33331V1.33398ZM10.6666 14.6673H2.66665C1.93065 14.6673 1.33331 14.07 1.33331 13.334V5.33398C1.33331 4.59798 1.93065 4.00065 2.66665 4.00065H10.6666C11.4026 4.00065 12 4.59798 12 5.33398V13.334C12 14.07 11.4026 14.6673 10.6666 14.6673ZM5.99998 8.66732H3.99998V10.0007H5.99998V12.0007H7.33331V10.0007H9.33331V8.66732H7.33331V6.66732H5.99998V8.66732Z'
      fill='inherit'
    />
  </svg>
);
